import { checkApiHealth } from '@/services/common';
import { useState } from 'react';
import { IconWrapper } from '../ui/icon-wrapper';
import MaintainIcon from '/public/maintain.svg';
import { useI18n } from '@/hooks/use-i18n';

const MaintenancePage = () => {
  const { t } = useI18n('error');
  const [isCheckingHealth, setIsCheckingHealth] = useState(false);

  const checkHealth = async () => {
    setIsCheckingHealth(true);
    try {
      await checkApiHealth();
      // If we get here, the API is healthy
      window.location.reload();
    } catch (error) {
      console.error('API health check failed:', error);
    } finally {
      setIsCheckingHealth(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="text-center max-w-md">
        <div className="mb-4 flex items-center justify-center">
          <IconWrapper icon={MaintainIcon} size={208} className="h-[95px]" />
        </div>

        <h1 className="text-[14px] font-bold text-[#000000BF] mb-3">
          {t('maintenance.title')}
        </h1>

        <p className="text-[14px] text-[#00000073] mb-4">
          {t('maintenance.message')}
        </p>

        <button
          onClick={checkHealth}
          className="text-[13px] px-4 py-[11px] bg-[#7171EE] text-white rounded-lg font-medium transition-all hover:bg-[#5858CC] focus:outline-none focus:ring-2 focus:ring-[#7171EE] focus:ring-opacity-50 cursor-pointer"
        >
          {isCheckingHealth
            ? t('maintenance.checking')
            : t('maintenance.healthCheck')}
        </button>
      </div>
    </div>
  );
};

export default MaintenancePage;
